import { render, staticRenderFns } from "./DuelsFilterSort.vue?vue&type=template&id=3055e14a&scoped=true"
import script from "./DuelsFilterSort.vue?vue&type=script&lang=js"
export * from "./DuelsFilterSort.vue?vue&type=script&lang=js"
import style0 from "./DuelsFilterSort.vue?vue&type=style&index=0&id=3055e14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055e14a",
  null
  
)

export default component.exports